import { Trans } from '@lingui/react/macro';
import type { HTMLAttributes } from 'react';

import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

const Empty = ({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) => {
  const resolvedChildren = children ?? <Trans>No Data Available</Trans>;
  return (
    <div
      {...rest}
      className={cn('flex size-full flex-row items-center justify-center gap-2 p-8', className)}
    >
      <Text className="text-center text-gray-500" variant="body1" color="grey">
        {resolvedChildren}
      </Text>
    </div>
  );
};
export default Empty;
